import WorkoutForm from './WorkoutForm'
export default WorkoutForm
